export default __webpack_public_path__ + "static/media/35.0721dd31.png";